import React from "react";

import { TextField, Button, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import Typo from "@material-ui/core/Typography";

// مشاوره - مشاوره بزرگسالان

class Adults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FullName: "",
      PhoneNumber: "",
      ALT_PhoneNumber: "",
      Address: "",
      Job: "",
      EducationLevel: "",
      Age: "",
      Meeting: 1, // 1 : Online , 2 : physical meeting
      InvalidFields: [],
      Errors: {
        FullName: false,
        PhoneNumber: false,
        ALT_PhoneNumber: false,
        Address: false,
        Job: false,
        EducationLevel: false,
        Age: false,
      },
    };
  }

  fieldsToBeValidate = [
    "Age",
    "FullName",
    "ALT_PhoneNumber",
    "PhoneNumber",
    "Address",
  ];

  ChangeHandler = (e) => {
    const { HandleData } = this.props;
    this.setState({ [e.target.name]: e.target.value });
    const stageData = this.state;
    stageData.Errors = null;
    HandleData(stageData, "step3");
    // this.Validator();
  };

  componentDidMount() {
    this.props.NextBtn(false);
  }

  Validator = (e) => {
    let isAllValid = true;
    for (const field of this.fieldsToBeValidate) {
      if (!this.state[field]) {
        isAllValid = false;
      }
    }
    const elName = e.target.name;
    if (this.fieldsToBeValidate.includes(elName)) {
      const isValid = !this.state[elName];
      this.setState({
        Errors: {
          ...this.state.Errors,
          [elName]: isValid,
        },
      });
    }
    this.props.NextBtn(isAllValid);
  };

  ValidateSingle = (elName) => {
    this.setState({
      ...this.state.Errors,
      [elName]: !this.state[elName],
    });
  };

  ValidateField = (e) => {
    const INVALID_FIELDS = this.state.InvalidFields;
    if (e.target.value === "" || e.target.value === 0) {
      INVALID_FIELDS.push(e.target.name);
    } else if (INVALID_FIELDS.includes(e.target.name)) {
      const NAME = e.target.name;
      const INDEX = INVALID_FIELDS.indexOf(NAME);
      INVALID_FIELDS.splice(INDEX, 1);
    }
    this.setState({
      InvalidFields: INVALID_FIELDS,
    });

    this.props.NextBtn(this.state.InvalidFields.length === 0);
  };

  Require = (FieldName) => {
    return {
      onBlur: this.ValidateField,
      error: this.state.InvalidFields.includes(FieldName),
    };
  };

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <Typo
            variant={"h5"}
            className={"p-2 font-weight-bold text-right mb-2"}
          >
            مشاوره
          </Typo>
        </div>
        <div className="col-12">
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                // error={this.state.Errors.FullName}
                className="w-100"
                name="FullName"
                label="نام و نام خانوادگی"
                defaultValue={this.state.FullName}
                onChange={this.ChangeHandler}
                // onBlur={this.Validator}
                {...this.Require("FullName")}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="PhoneNumber"
                label="شماره تماس"
                defaultValue={this.state.PhoneNumber}
                type="number"
                onChange={this.ChangeHandler}
                {...this.Require("PhoneNumber")}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="ALT_PhoneNumber"
                label="شماره تماس یکی از نزدیکان"
                defaultValue={this.state.ALT_PhoneNumber}
                type="number"
                onChange={this.ChangeHandler}
                {...this.Require("ALT_PhoneNumber")}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="Address"
                label="آدرس"
                defaultValue={this.state.Address}
                onChange={this.ChangeHandler}
                {...this.Require("Address")}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="Age"
                label="سن"
                defaultValue={this.state.Age}
                onChange={this.ChangeHandler}
                // onBlur={this.Validator}
                variant={"outlined"}
                {...this.Require("Age")}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <Typo>انتخاب نوع مشاوره</Typo>
              <Button
                color={"primary"}
                className={"mr-2"}
                variant={this.state.Meeting === 1 ? "contained" : "text"}
                onClick={() => this.setState({ Meeting: 1 })}
              >
                آنلاین
              </Button>
              <Button
                color={"primary"}
                className={"mr-2"}
                variant={this.state.Meeting === 2 ? "contained" : "text"}
                onClick={() => this.setState({ Meeting: 2 })}
              >
                حضوری
              </Button>
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <TextField
                className="w-100"
                name="Job"
                label="شغل"
                defaultValue={this.state.Job}
                onChange={this.ChangeHandler}
                {...this.Require("Job")}
                variant={"outlined"}
                color="secondary"
              />
            </div>
          </div>
          <div className="row mt-3 w-100">
            <div className="col-12">
              <FormControl>
                <InputLabel id='edu-level'>
                  سطح تحصیلات
                </InputLabel>
                <Select
                  className="w-100"
                  name="EducationLevel"
                  label="سطح تحصیلات"
                  defaultValue={this.state.EducationLevel}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                  labelId='edu-level'
                >
                  {['زیر دیپلم', 'دیپلم', 'فوق دیپلم', 'لیسانس', 'فوق لیسانس', 'دکترا'].map((item, index) =>
                    <MenuItem value={item} key={`EDU-${index}-${item}`}>
                      {item}
                    </MenuItem>)}
                </Select>
              </FormControl>
              {/* <TextField
                className="w-100"
                name="EducationLevel"
                label="سطح تحصیلات"
                defaultValue={this.state.EducationLevel}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
              /> */}
            </div>
          </div>

          <div className="row mt-3 w-100">
            <div className="col-12">
              <Typo
                variant={"h5"}
                className={"font-weight-bold text text-warning"}
              >
                {" "}
                لطفا نکات زیر را در نظر داشته باشید:{" "}
              </Typo>
              <Typo variant={"body1"} className={"font-weight-bold"}>
                لطفا با توجه به شخصی که نیاز به مشاوره دارد گردد نه شخص نوبت
                گیرنده
              </Typo>
              <Typo variant={"body1"} className={"font-weight-bold"}>
                در صورت تاخیر در زمان حضور از زمان شما کسر خواهد شد
              </Typo>
              <Typo variant={"body1"} className={"font-weight-bold"}>
                پس از انتخاب روز و ساعت ، امکان لغو نوبت وجود ندارد
              </Typo>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Adults;
